import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import useMyQuotationSWR from '../../../../hooks/quotations/useMyQuotationSWR';
import { TableLoadingLayout } from '../../../layouts/LoadingLayouts/TableLoadingLayout';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { MyQuotationProducts } from '../../../shared/my-quotation/MyQuotationProducts';
import { styled } from '@mui/material/styles';
import { MyQuotationDetailsSummary } from '../../../my-quotation-details/MyQuotationDetailsSummary';
import { MyQuotationDetailsActions } from '../../../my-quotation-details/MyQuotationDetailsActions';

const StyledQuotationProductsWrapper = styled(Box)(() => ({
    '.css-1kdfscw-MuiPaper-root': {
        boxShadow: 'none !important',
    },
}));

export const MyQuotationDetails = () => {
    const { quoteId } = useParams();
    const { t } = useTranslation('quotations', {
        keyPrefix: 'MY_QUOTATIONS',
    });

    const { quote, isLoading, isError } = useMyQuotationSWR(quoteId);

    return (
        <>
            {isError && <Box>{t('LOADING_ERROR')}</Box>}
            {isLoading && <TableLoadingLayout />}
            {!isLoading && quote && (
                <>
                    <PageTitle>
                        {t('DETAILS.TITLE', { quoteId: quote.quoteNo })}
                    </PageTitle>
                    <MyQuotationDetailsActions quote={quote} />
                    <MyQuotationDetailsSummary quote={quote} />
                    <StyledQuotationProductsWrapper>
                        <MyQuotationProducts
                            lines={quote.salesQuoteLines}
                        ></MyQuotationProducts>
                    </StyledQuotationProductsWrapper>
                </>
            )}
        </>
    );
};
